import { FunctionComponent, Suspense } from 'react';

import { UseEventHandlerType } from '@/hooks/useEventHandler';

export type EventHandlerFacilitatorProps = Pick<
  UseEventHandlerType,
  'componentsState' | 'onCloseComponent'
> & {
  componentsRegistry: Partial<Record<string, FunctionComponent<any>>>;
};

const EventHandlerFacilitator = ({
  componentsState,
  onCloseComponent,
  componentsRegistry,
}: EventHandlerFacilitatorProps) => {
  return (
    <Suspense fallback={null}>
      {Object.keys(componentsState).map((componentName) => {
        const props = componentsState[componentName]?.();
        const Component = componentsRegistry[componentName];
        if (!Component) {
          return null;
        }

        return (
          <Component
            key={componentName}
            {...props}
            onClose={() => onCloseComponent(componentName)}
          />
        );
      })}
    </Suspense>
  );
};

export default EventHandlerFacilitator;
